/**
 * Check if executed in the browser
 * @returns boolean
 */
export const isBrowser = () => typeof window !== 'undefined';
